/**
 * 意大利语（it）
 */

import itLocale from 'element-ui/lib/locale/lang/it'

export default {
  ...itLocale,
  common: {},
  // 语言
  lang: {
    english: 'Inglese',
    spanish: 'Spagnolo',
    japanese: 'Giapponese',
    portuguese: 'Portoghese',
    french: 'Francese',
    russian: 'Russo',
    arabic: 'Arabo',
    german: 'Tedesco',
    italian: 'Italiano',
    vietnam: 'Vietnam',
    turkey: 'Tacchino',
    korean: 'Coreano',
    thai: 'Thailandese.',
    dutch: 'Olandese',
    hebrew: 'Ebraico',
    indonesian: 'Indonesiano'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
